import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { type UserOrderResponseWithFlags } from '@redteclab/api/clients/bully'

import { Button } from 'base-ui'

import { DirectContactFormOrderProductsSelectionCard } from './DirectContactFormOrderProductsSelectionCard/DirectContactFormOrderProductsSelectionCard'

export const DirectContactFormOrderProductsSelectionList: FC<{
  hasMore: boolean
  isLoading: boolean
  miraklReturnAvailableOrderIds: ReadonlySet<string>
  onLoadMore: () => void
  orders: UserOrderResponseWithFlags[]
}> = ({
  hasMore,
  isLoading,
  miraklReturnAvailableOrderIds,
  onLoadMore,
  orders,
}) => {
  const subOrderCount = orders.reduce(
    (count, order) => count + (order.subOrders?.length ?? 0),
    0,
  )
  const shouldShowLoadMoreButton = hasMore && !isLoading

  return (
    <div className="flex flex-col gap-6">
      <div
        aria-busy={isLoading}
        className={clsx(
          'grid min-w-0 gap-4',
          subOrderCount === 1 ? 'tablet:grid-cols-1' : 'tablet:grid-cols-2',
        )}
      >
        {orders.flatMap((order) =>
          (order.subOrders ?? []).map((subOrder) => (
            <DirectContactFormOrderProductsSelectionCard
              isMiraklOrderReturnAvailable={
                subOrder.subOrderId !== undefined &&
                miraklReturnAvailableOrderIds.has(subOrder.subOrderId)
              }
              key={`${order.orderMasterData?.orderNumber}-${subOrder.subOrderId}`}
              order={order}
              subOrder={subOrder}
            />
          )),
        )}
      </div>

      {shouldShowLoadMoreButton ? (
        <Button
          className="self-center tablet:w-1/2"
          color="secondary"
          data-qa-id="contact-form-load-more-products-button"
          onClick={onLoadMore}
          type="button"
        >
          <FormattedMessage id="direct.contact.form.load.more.orders" />
        </Button>
      ) : null}
    </div>
  )
}
